import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41be448a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41be448a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be448a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41be448a')) {
      api.createRecord('41be448a', component.options)
    } else {
      api.reload('41be448a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41be448a&scoped=true", function () {
      api.rerender('41be448a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/riskControlLittleB/index.vue"
export default component.exports